import React from 'react';
import styles from './SummaryHeaderWrapper.module.scss';
import clsx from 'clsx';

export default function SummaryHeaderWrapper({ className, children }) {
  return <div className={clsx(className && className, styles.wrapper)}>{children}</div>;
}
